import { useApiGet } from "@ametie/vue-muza-use";

export interface CheckTokenResponse {
  isValid: boolean
}

export const useCheckTokenRequest = (token: string) => {
  return useApiGet<CheckTokenResponse>(`/auth/check-user-token/${token}`, {
    immediate: false,
    authMode: "public",
    skipErrorNotification: true,
  });
};
